import {
   CheckPhoneNumberService,
   GetAgentService,
   GetCitesService,
   GetDesCitiesService,
   GetGeneralCitesService,
   GetGeneralUserService,
   GetReportService,
   GetStatesService,
   GetTrakingSerivece,
   GetUserDetailsService,
   GetUserInfoService,
   getPreDataService,
   GetUserServicesSevice,
   GetUserStatesService,
   PatchUserPasswordService,
   PatchUserService,
   PostComplaintService,
   PostEstimateService,
} from '../../services/registerApi';
import { showErrorMessage } from '../../services/httpService';

export const GetTracking = async (number, token) => {
   const response = await GetTrakingSerivece(number, token);
   if (response.error) {
      number && showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetUser = async (addService, token) => {
   const response = await getPreDataService(addService, token);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetGeneralUser = async (addService) => {
   const response = await GetGeneralUserService(addService);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetAgent = async () => {
   const response = await GetAgentService();
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetStates = async () => {
   const response = await GetStatesService();
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetUserStates = async (id, token) => {
   const response = await GetUserStatesService(id, token);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetCites = async (id, token) => {
   const response = await GetCitesService(id, token);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetGeneralCites = async (id, token) => {
   const response = await GetGeneralCitesService(id, token);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const PostComplaint = async (firstName, lastName, subject, text, phoneNumber, token) => {
   const response = await PostComplaintService(
      firstName,
      lastName,
      subject,
      text,
      phoneNumber,
      token
   );
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetUserInfo = async () => {
   const response = await GetUserInfoService();
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const PatchUserInfo = async (userInfo, token) => {
   const response = await PatchUserService(userInfo, token);
   if (response.error) {
      // showErrorMessage(response);
      showErrorMessage(response);
      return false;
   } else {
      return true;
   }
};

export const PatchUserPassword = async (pass, token) => {
   const response = await PatchUserPasswordService(pass, token);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};
export const GetUserServices = async (type) => {
   const response = await GetUserServicesSevice(type);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetUserDetails = async (trackNum, token) => {
   const response = await GetUserDetailsService(trackNum, token);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetReport = async (trackNum) => {
   const response = await GetReportService(trackNum);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const GetDesCities = async (stateId, token) => {
   const response = await GetDesCitiesService(stateId, token);
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};

export const PostEstimate = async (
   packages,
   packing,
   origin,
   destination,
   deliveryTypeId,
   assurance,
   token
) => {
   const response = await PostEstimateService(
      packages,
      packing,
      origin,
      destination,
      deliveryTypeId,
      assurance,
      token
   );
   if (response.error) {
      showErrorMessage(response);
      return { status: false };
   } else {
      return { status: true, data: response.data };
   }
};
